module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "z-index": _vm.params.zIndex || null,
      "width": "450px",
      "show-close": false
    },
    on: {
      "close": _vm.goOn
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('skirental.timeout.hm')))]), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.timeout.question')))]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('p', [_vm._v("Din bokning är reserverad. Eftersom du har lämnat din bokning kommer det du har reserverat att släppas fritt för andra att boka snart.")]) : _vm._e(), _vm._v(" "), (_vm.params.inactive && _vm.params.inactive()) ? _c('div', [(_vm.$store.state.isOnSite) ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.timeout.text')))]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('p', [_vm._v("Tid kvar:")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.params.inactive()) ? _c('h2', [_vm._v(_vm._s(_vm.timeLeft()))]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.goOn
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.timeout.cta-continue')))]), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('button', {
    staticClass: "white",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.timeout.cta-cancel')))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-423a9206"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/TimeoutModal.vue
// module id = 941
// module chunks = 0